import React, { useState, useEffect } from 'react';
import { Input, Button, Alert, Card, CardBody, Row, Col, Spinner } from 'reactstrap';
import { IconLock, IconLockOpen, IconCloudUpload, IconLogout } from '@tabler/icons-react';
import { useDesignStore } from '../../../store/designStore';

const DbSyncSection = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const {
        adminToken,
        adminEmail,
        adminLoginLoading,
        adminLoginError,
        adminSaveLoading,
        adminSaveSuccess,
        loginAdmin,
        logoutAdmin,
        saveDesignConfig,
        resetSaveSuccess,
    } = useDesignStore();

    useEffect(() => {
        if (adminToken) {
            setEmail('');
            setPassword('');
        }
    }, [adminToken]);

    useEffect(() => {
        if (adminSaveSuccess === true) {
            const timer = setTimeout(() => {
                resetSaveSuccess();
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [adminSaveSuccess, resetSaveSuccess]);

    const handleLoginSubmit = (e) => {
        e.preventDefault();
        if (email.trim() && password) {
            loginAdmin(email.trim(), password);
        }
    };

    return (
        <Card className="border-primary mb-4 bg-light shadow-sm">
            <CardBody className="p-3">
                <div className="d-flex align-items-center mb-3">
                    {adminToken ? (
                        <IconLockOpen size={20} className="text-success me-2" />
                    ) : (
                        <IconLock size={20} className="text-primary me-2" />
                    )}
                    <h3 className="h6 fw-bold mb-0 text-primary">Direkte Datenbank-Synchronisierung</h3>
                </div>

                {!adminToken ? (
                    <form onSubmit={handleLoginSubmit}>
                        <p className="text-muted small mb-3">
                            Melden Sie sich mit Ihren Administrator-Zugangsdaten an, um Änderungen direkt in der
                            Datenbank zu speichern.
                        </p>

                        {adminLoginError && (
                            <Alert color="danger" className="small py-2 mb-3">
                                ⚠️ {adminLoginError}
                            </Alert>
                        )}

                        <Row className="g-2 mb-2">
                            <Col sm={6}>
                                <Input
                                    type="email"
                                    size="sm"
                                    placeholder="E-Mail-Adresse"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    disabled={adminLoginLoading}
                                />
                            </Col>
                            <Col sm={6}>
                                <Input
                                    type="password"
                                    size="sm"
                                    placeholder="Passwort"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    disabled={adminLoginLoading}
                                />
                            </Col>
                        </Row>
                        <Button
                            type="submit"
                            size="sm"
                            color="primary"
                            className="w-100 d-flex align-items-center justify-content-center"
                            disabled={adminLoginLoading || !email.trim() || !password}
                        >
                            {adminLoginLoading ? (
                                <>
                                    <Spinner size="sm" className="me-2" />
                                    Anmeldung läuft...
                                </>
                            ) : (
                                <>
                                    <IconLock className="me-1" size={14} />
                                    Als Admin anmelden
                                </>
                            )}
                        </Button>
                    </form>
                ) : (
                    <div>
                        <div className="d-flex justify-content-between align-items-center mb-3 bg-white p-2 rounded border small">
                            <span className="text-success fw-bold d-flex align-items-center">
                                <span
                                    className="bg-success rounded-circle me-1"
                                    style={{ width: '8px', height: '8px', display: 'inline-block' }}
                                ></span>
                                Eingeloggt als {adminEmail}
                            </span>
                            <Button
                                size="xs"
                                color="outline-danger"
                                className="py-0 px-2 d-flex align-items-center"
                                style={{ fontSize: '0.75rem' }}
                                onClick={logoutAdmin}
                            >
                                <IconLogout size={12} className="me-1" />
                                Abmelden
                            </Button>
                        </div>

                        <Button
                            size="sm"
                            color="success"
                            className="w-100 d-flex align-items-center justify-content-center py-2"
                            onClick={saveDesignConfig}
                            disabled={adminSaveLoading}
                        >
                            {adminSaveLoading ? (
                                <>
                                    <Spinner size="sm" className="me-2" />
                                    Wird in Datenbank gespeichert...
                                </>
                            ) : (
                                <>
                                    <IconCloudUpload className="me-1" size={16} />
                                    Änderungen direkt in Datenbank speichern
                                </>
                            )}
                        </Button>

                        {adminSaveSuccess === true && (
                            <Alert color="success" className="small py-2 mt-2 mb-0">
                                ✅ Änderungen wurden erfolgreich in der Datenbank gespeichert!
                            </Alert>
                        )}

                        {adminSaveSuccess === false && (
                            <Alert color="danger" className="small py-2 mt-2 mb-0">
                                ❌ Fehler beim Speichern der Konfiguration in der Datenbank.
                            </Alert>
                        )}
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default DbSyncSection;
